module.exports = __webpack_public_path__ + "img/wayfair.78a97090.svg";